import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '../../design-system/primitives/index.js'
import BottomSheet from '../../design-system/patterns/BottomSheet.jsx'
import { HOME_COPY } from '../../config/homeCopy.js'

function HowContent({ onStart, onClose, actionLabel = 'Start my kitchen' }) {
  return (
    <>
      <div className="how-it-works__video-slot" aria-label="Captain Cook walkthrough placeholder">
        <i className="fas fa-play" aria-hidden="true" />
        <span>Walkthrough coming soon</span>
      </div>
      <ol className="how-it-works__steps">
        {HOME_COPY.steps.map(([number, label]) => (
          <li key={number}>
            <span aria-hidden="true">{number}</span>
            {label}
          </li>
        ))}
      </ol>
      <div className="how-it-works__actions">
        <Button variant="primary" onClick={onStart}>{actionLabel}</Button>
        <Button variant="secondary" onClick={onClose}>Close</Button>
      </div>
    </>
  )
}

export default function HowItWorks({ open, onClose, onStart, actionLabel = 'Start my kitchen', mobile = false }) {
  if (mobile) {
    return (
      <BottomSheet open={open} onClose={onClose} className="how-it-works__sheet" aria-label="How Captain Cook works">
        <div className="how-it-works__mobile">
          <h2>{HOME_COPY.howTitle}</h2>
          <p>{HOME_COPY.howLead}</p>
          <HowContent onStart={onStart} onClose={onClose} actionLabel={actionLabel} />
        </div>
      </BottomSheet>
    )
  }

  return (
    <Modal open={open} onClose={onClose} titleId="how-it-works-title" contentClassName="how-it-works__modal">
      <ModalHeader>
        <div>
          <h2 id="how-it-works-title">{HOME_COPY.howTitle}</h2>
          <p>{HOME_COPY.howLead}</p>
        </div>
        <Button variant="ghost" onClick={onClose} aria-label="Close how it works">×</Button>
      </ModalHeader>
      <ModalBody>
        <HowContent onStart={onStart} onClose={onClose} actionLabel={actionLabel} />
      </ModalBody>
      <ModalFooter />
    </Modal>
  )
}
